<template>
  <router-view/>
</template>


<style src="./css/resets/normalize.css"/>
<style src="./css/resets/reset.css"/>
<style src="./css/resets/typography.css"/>

<style src="./css/global.css"/>
<style src="./css/admin.css"/>

<style src="./css/animations/buttons.css"/>
<style src="./css/animations/cursor.css"/>
<style src="./css/animations/constructor.css"/>


<style>
#app {
  min-height: 100vh;
  min-width: 1200px;
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  background-color: #121212;
  overflow: hidden;
}
body {
  background-color: #121212;
}
</style>
